// web-v2/src/services/document-import.service.js
//
// THE NAMING QUEUE'S CALLS (paperwork-1 D14, A8; L4-2; screen 9). Every read and write is the server's
// (routes/document-import.routes.js): the queue with its suggestions and choices, the ledger rows and holders one policy
// offers, the name door (placeDocument then confirmDocument) and the confirm door. The Paperwork tab's "Confirm it is this
// policy's" calls confirmImportedDocument, the same door. The refusals a screen renders as a sentence are expected (no toast
// beside them).
import { api } from '@/lib/api.js';

const enc = encodeURIComponent;
const NAME_EXPECTED = [
  { status: 400, code: 'BAD_REQUEST' }, { status: 409, code: 'REPLACES_UNANSWERED' }, { status: 409, code: 'NOT_AN_IMPORT' }, { status: 409, code: 'ALREADY_CONFIRMED' }, { status: 409, code: 'SUPERSEDED' },
  { status: 409, code: 'NO_POLICY_ROW' }, { status: 409, code: 'OUR_OWN_PAPER' }, { status: 409, code: 'LINKED_TO_TRANSACTION' }, { status: 409, code: 'IN_A_REPLACEMENT_CHAIN' },
  { status: 409, code: 'DUPLICATE_CONFLICT' }, { status: 409, code: 'DOC_ON_OTHER_TXN' }, { status: 409, code: 'DOC_NOT_ON_POLICY' }, { status: 409, code: 'NOT_PLACED' }, { status: 409, code: 'NOT_NAMED' }, { status: 503, code: 'store_unavailable' },
  { status: 409, code: 'NOT_KEPT' }, { status: 409, code: 'NOT_SET_ASIDE' }, { status: 409, code: 'DOC_CHANGED' }, { status: 404, code: 'NOT_FOUND' },
  { status: 400, code: 'SIGNED_ON_REQUIRED' }, { status: 400, code: 'SIGNED_ON_INVALID' }, { status: 409, code: 'IMPORT_PLACED' }, { status: 409, code: 'NO_WORKDRIVE_FILE' },
  { status: 409, code: 'NO_SHA256' }, { status: 409, code: 'NO_DEAL' }, { status: 409, code: 'ALREADY_FILED_AS_APPLICATION' }, { status: 409, code: 'ALREADY_FILED' },
];

export function getImportQueue() {
  return api.get('/api/tracon/documents/import-queue', { timeoutMs: 60_000 });
}
export function getNamingChoices(policyId, klass) {
  return api.get(`/api/tracon/documents/import-queue/choices?policy_id=${enc(policyId)}&klass=${enc(klass || '')}`);
}
// { klass, policyId | accountId, transactionId?, interestId?, replacesDocumentId? ('none' is the explicit no) }
export function nameImportedDocument(documentId, statement) {
  return api.post(`/api/tracon/documents/${enc(documentId)}/name`, statement, { expected: NAME_EXPECTED });
}
export function confirmImportedDocument(documentId) {
  return api.post(`/api/tracon/documents/${enc(documentId)}/confirm`, {}, { expected: NAME_EXPECTED });
}
// "Not a document we keep" (round 2, Q42): the import is set aside (nothing deleted); keepImportedDocument is the undo.
export function setImportAsideNotKept(documentId, reason) {
  return api.post(`/api/tracon/documents/${enc(documentId)}/not-kept`, reason ? { reason } : {}, { expected: NAME_EXPECTED });
}
// "Signed application" (round 2, Q38): { policyId, signedOn: 'YYYY-MM-DD' }; filed through the one application writer, never placed.
export function fileImportAsSignedApplication(documentId, { policyId, signedOn }) {
  return api.post(`/api/tracon/documents/${enc(documentId)}/signed-application`, { policyId, signedOn }, { expected: NAME_EXPECTED });
}
export function keepImportedDocument(documentId) {
  return api.post(`/api/tracon/documents/${enc(documentId)}/keep`, {}, { expected: NAME_EXPECTED });
}
// THE BULK TOOLS (David 2026-11-03): the agency's live accounts to file on, and the bulk door. The door takes at most
// BULK_CHUNK ids per call (the server's BULK_MAX) and answers each row's own result; a whole-batch refusal is a 4xx.
export const BULK_CHUNK = 25;
export function getFilingAccounts() {
  return api.get('/api/tracon/documents/import-queue/accounts', { timeoutMs: 60_000 });
}
// { action: 'file', ids, klass: 'as_read' | <class>, account: 'own' | <account id> } or { action: 'not_kept', ids, reason? }
export function bulkImportAction(body) {
  return api.post('/api/tracon/documents/import-queue/bulk', body, { timeoutMs: 120_000, expected: [...NAME_EXPECTED, { status: 409, code: 'ACCOUNT_MERGED' }] });
}
